import { render, staticRenderFns } from "./Setups.vue?vue&type=template&id=2af3a929&"
import script from "./Setups.vue?vue&type=script&lang=js&"
export * from "./Setups.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports